module.exports = __webpack_public_path__ + "static/media/affiliate-products-view.ea49f436.png";